"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _modalContext = require("./modal-context");

var _modal = require("./modal.styles");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const defaultProps = {
  className: '',
  justify: 'flex-end',
  autoMargin: true
};
const preClass = 'nextui-modal-footer';

const ModalFooter = ({
  children,
  className,
  justify,
  autoMargin: autoMarginProp,
  css,
  ...props
}) => {
  const {
    autoMargin: autoMarginContext,
    noPadding
  } = (0, _react.useContext)(_modalContext.ModalContext);
  const autoMargin = (0, _react.useMemo)(() => {
    return autoMarginContext !== undefined ? autoMarginContext : autoMarginProp;
  }, [autoMarginProp, autoMarginContext]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_modal.StyledModalFooter, {
    className: (0, _clsx.default)(preClass, {
      [`${preClass}-auto-margin`]: autoMargin,
      [`${preClass}-no-padding`]: noPadding
    }, className),
    noPadding: noPadding,
    autoMargin: autoMargin,
    css: {
      justifyContent: justify,
      ...css
    },
    ...props,
    children: children
  });
};

ModalFooter.toString = () => '.nextui-modal-footer';

const MemoModalFooter = /*#__PURE__*/_react.default.memo(ModalFooter);

var _default = (0, _withDefaults.default)(MemoModalFooter, defaultProps);

exports.default = _default;
module.exports = exports.default;